import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SignUpRoutingModule} from './sign-up-routing.module';
import {SignUpComponent} from './sign-up.component';
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {TranslateModule} from "@ngx-translate/core";
import {OptionModule} from "@app/presentation/components/option/option.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {ReactiveFormsModule} from "@angular/forms";
import {IsClientComponent} from './steps/is-client/is-client.component';
import {IsCompanyComponent} from './steps/is-company/is-company.component';
import {FormFieldModule} from "@app/presentation/components/form-field/form-field.module";
import {UserPasswordComponent} from './steps/user-password/user-password.component';
import {CheckboxModule} from "@app/presentation/components/checkbox/checkbox.module";
import {OnboardingModule} from "@app/presentation/components/onboarding/onboarding.module";
import {DataComponent} from './steps/data/data.component';
import {PostalCodeComponent} from './steps/postal-code/postal-code.component';
import {AngularSvgIconModule} from "angular-svg-icon";
import {DialogsModule} from '@app2u/dialogs';
import {ModalModule} from "@app/presentation/services/modal/modal.module";

@NgModule({
  declarations: [
    SignUpComponent,
    IsClientComponent,
    IsCompanyComponent,
    UserPasswordComponent,
    DataComponent,
    PostalCodeComponent,
  ],
    imports: [
        CommonModule,
        SignUpRoutingModule,
        AppBarModule,
        TranslateModule,
        OptionModule,
        ButtonModule,
        ReactiveFormsModule,
        FormFieldModule,
        CheckboxModule,
        OnboardingModule,
        DialogsModule,
        AngularSvgIconModule,
        ModalModule,
    ]
})
export class SignUpModule { }
